<template>
    <div>
        <div class="bg-dark m-b-30">
            <div class="container">
                <div class="row p-b-60 p-t-60">
                    <div class="col-md-6 text-white p-b-30">
                        <div class="media">
                            <div class="avatar avatar mr-3">
                                <div class="avatar-title bg-success rounded-circle mdi mdi-view-list"></div>
                            </div>
                            <div class="media-body">
                                <h3 class="p-t-10">{{ pageTitle }}</h3>
                                <p class="opacity-75"></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-center m-b-30 ml-auto">
                        <div class="text-md-right">
                            <router-link v-can="'category.read'" is="el-button" :to="{name: 'departments'}" icon="el-icon-s-order" type="primary">
                                {{ $t('category.button.all') }}
                            </router-link>
                            <el-button v-can="'category.create'" @click="showCreateDialog" icon="el-icon-plus"  type="success">
                                {{ $t('category.button.create') }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-category @close="closeCreateDialog" :display="displayCreateDialog" @created="categoryCreated"></create-category>
        <transition name="slide-fade">
            <router-view @parent-title="updateTitle"/>
        </transition>
    </div>
</template>

<script>
import CreateCategory from './Modal/CreateEditCategory'
export default {
  name: 'Departments',
  components: { CreateCategory },
  data () {
    return {
      pageTitle: '',
      displayCreateDialog: false
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    showCreateDialog () {
      this.displayCreateDialog = true
    },
    closeCreateDialog () {
      this.displayCreateDialog = false
    },
    categoryCreated (data) {
      this.$emit('new-category', data)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
